import { render, staticRenderFns } from "./AgreementsCreate.vue?vue&type=template&id=945bdb60&scoped=true&"
import script from "./AgreementsCreate.vue?vue&type=script&lang=js&"
export * from "./AgreementsCreate.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsCreate.vue?vue&type=style&index=0&id=945bdb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945bdb60",
  null
  
)

export default component.exports